function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/allplaceapplication/download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ryxqsyzu2a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/allplaceapplication/download (clip mask)",
    style: {
      fill: "current"
    },
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/allplaceapplication/download (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/allplaceapplication/download",
    style: {
      clipPath: "url(#ryxqsyzu2a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/allplaceapplication/download (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/allplaceapplication/download (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/allplaceapplication/calendar",
    style: {
      clipPath: "url(#ryxqsyzu2a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/allplaceapplication/calendar (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/allplaceapplication/calendar (style)",
    transform: "translate(1 1)",
    style: {
      fill: "none"
    },
    d: "M0 0h14v14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.44 14H.56a.56.56 0 0 1-.56-.56V1.82a.56.56 0 0 1 .56-.56H3.5V.14A.14.14 0 0 1 3.64 0h.98a.14.14 0 0 1 .14.14v1.12h4.48V.14A.14.14 0 0 1 9.38 0h.98a.14.14 0 0 1 .14.14v1.12h2.94a.56.56 0 0 1 .56.56v11.62a.56.56 0 0 1-.56.56zM1.26 6.09v6.65h11.48V6.09zm0-3.57V4.9h11.48V2.52H10.5v.84a.14.14 0 0 1-.14.14h-.98a.14.14 0 0 1-.14-.14v-.84H4.76v.84a.14.14 0 0 1-.14.14h-.98a.14.14 0 0 1-.14-.14v-.84z",
    transform: "translate(1 1)",
    style: {
      fill: "current"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d4fd8a3d87cea8dc8f591a3aff3a32cc.svg";
export { ForwardRef as ReactComponent };